import GenericModel from './generic-model';
import ProjectInvoice from './invoice/project-invoice';
import Product from './product/product';
import BoardPart from './product/board/board-part';

export class PriceLine extends GenericModel {
  placementLine?: boolean;
  projectInvoice?: ProjectInvoice;
  product?: Product;
  boardPart?: BoardPart;
  text?: string;
  price?: string;
  override?: string;
  displaySuffix?: string;

  constructor() {
    super();
  }
}

export const OVERRIDES = {
  TRANSPORT_PRICE: { value: 'TRANSPORT_PRICE' },
  PAINTED_POSTS_PRICE: { value: 'PAINTED_POSTS_PRICE' },
  DISTANCE_TO_BOTTOM_PRICE: { value: 'DISTANCE_TO_BOTTOM_PRICE' },
  REPO_PRICE: { value: 'REPO_PRICE' },
  PRODUCTION_PRICE: { value: 'PRODUCTION_PRICE' },
  CONSTRUCTION_PRICE: { value: 'CONSTRUCTION_PRICE' },
  PLACEMENT_PRICE: { value: 'PLACEMENT_PRICE' }
};
